import api from './api';

// ── Account / item type helpers ───────────────────────────────────────────────

export async function searchLogAccounts(query) {
  const response = await api.get(`/staff/logs/search-accounts?q=${encodeURIComponent(query)}`);
  if (response.data.error !== undefined) throw new Error(response.data.error);
  return response.data.result;
}

export async function searchItemTypes(query) {
  const response = await api.get(`/staff/logs/item-types?q=${encodeURIComponent(query)}`);
  if (response.data.error !== undefined) throw new Error(response.data.error);
  return response.data.result;
}

export async function getChatModes() {
  const response = await api.get('/staff/logs/chat/modes');
  if (response.data.error !== undefined) throw new Error(response.data.error);
  return response.data.result;
}

// ── Log endpoints ─────────────────────────────────────────────────────────────

function buildParams({ userId, from, to, page, pageSize, chatMode, itemType, actionTypes } = {}) {
  const params = new URLSearchParams();
  if (userId != null) params.set('userId', userId);
  if (from) params.set('from', from);
  if (to) params.set('to', to);
  if (page != null) params.set('page', page);
  if (pageSize != null) params.set('pageSize', pageSize);
  if (chatMode != null) params.set('chatMode', chatMode);
  if (itemType != null) params.set('itemType', itemType);
  if (actionTypes != null && actionTypes.length > 0) params.set('actionTypes', actionTypes.join(','));
  return params.toString() ? `?${params}` : '';
}

export async function getLoginLogs(opts) {
  const response = await api.get(`/staff/logs/logins${buildParams(opts)}`);
  if (response.data.error !== undefined) throw new Error(response.data.error);
  return response.data.result;
}

export async function getChatLogs(opts) {
  const response = await api.get(`/staff/logs/chat${buildParams(opts)}`);
  if (response.data.error !== undefined) throw new Error(response.data.error);
  return response.data.result;
}

export async function getWhisperChannels({ userId, from, to } = {}) {
  const params = buildParams({ userId, from, to });
  const response = await api.get(`/staff/logs/chat/whispers${params}`);
  if (response.data.error !== undefined) throw new Error(response.data.error);
  return response.data.result;
}

export async function getItemLogs(opts) {
  const response = await api.get(`/staff/logs/items${buildParams(opts)}`);
  if (response.data.error !== undefined) throw new Error(response.data.error);
  return response.data.result;
}

export async function getTradeLogs(opts) {
  const response = await api.get(`/staff/logs/trades${buildParams(opts)}`);
  if (response.data.error !== undefined) throw new Error(response.data.error);
  return response.data.result;
}

export async function getTradeItems(tradeId, initiatorUserId) {
  const response = await api.get(`/staff/logs/trades/${tradeId}/items?initiatorUserId=${initiatorUserId}`);
  if (response.data.error !== undefined) throw new Error(response.data.error);
  return response.data.result;
}

export async function getVendingActionTypes() {
  const response = await api.get('/staff/logs/vending/action-types');
  if (response.data.error !== undefined) throw new Error(response.data.error);
  return response.data.result;
}

export async function getVendingLogs(opts) {
  const response = await api.get(`/staff/logs/vending${buildParams(opts)}`);
  if (response.data.error !== undefined) throw new Error(response.data.error);
  return response.data.result;
}
